// extracted by mini-css-extract-plugin
export default {"c-modal":"modal_c-modal__oqPrk","backdrop":"modal_backdrop__zMQY7"};